// import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import RecordSection from "./RecordSection";
import ConsentForm from "./ConsentForm";
import { AiFillBackward, AiOutlineArrowLeft, AiOutlineClose } from "react-icons/ai";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ApiService from "../../../ApiService";
import Beta from "../../../assets/beta_version.png";
import { clinicianIdFromRefreshAuth, getLoggedInPersonName } from "../../../util/authUtil";

function getProductNames(data) {
  return data?.map(item => item.name).join(", ");
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const MODAL_STAGES = {
  CONSENT_FORM: "consent_form",
  RECORD_STAGE: "record_stage",
  SAVE_AS: "save_as"
};

const TRANSCRIBE_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED"
};

export function TranscribeModal({ show, onHide, transcribeId, patientDetails, referenceDetails, referenceId, referenceType }) {
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const handleSnackClose = () => {
    setSnackOpen(false);
  };
  /*
   * @param {boolean} error
   * @param {boolean} success
   * @param {string} msg
   */
  const errorSuccessHandler = (error, success, msg) => {
    if (error) {
      setSnackOpen(true);
      setSnackText(msg);
      setSnackSeverity("error");
    }
    if (success) {
      setSnackOpen(true);
      setSnackText(msg);
      setSnackSeverity("success");
    }
  };

  const [modalStage, setModalStage] = useState(MODAL_STAGES.CONSENT_FORM);
  const [fileId, setFileId] = useState(null);
  const [transcribeAudioUrl, setTranscribeAudioUrl] = useState(null);
  const [transcribeOutputUrl, setTranscribeOutputUrl] = useState(null);
  const [transcribeSummaryUrl, setTranscribeSummaryUrl] = useState(null);
  const [transcribeStatus, setTranscribeStatus] = useState(null);
  const [transcribeData, setTranscribeData] = useState(null);
  const [noteType, setNoteType] = useState(null);
  const [isTranscribeConsumed, setIsTranscribeConsumed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authorId, setAuthorId] = useState(null);
  const [authorName, setAuthorName] = useState(null);

  // useEffect(() => {
  //   if (referenceId && patientDetails?.userId) {
  //     getTranscribeWithBookingIdAndPatientId(referenceId, patientDetails?.userId);
  //   }
  // }, [referenceId, patientDetails]);

  useEffect(() => {
    clinicianIdFromRefreshAuth().then(res => setAuthorId(res));
    getLoggedInPersonName().then(res => setAuthorName(res));
    if (transcribeId) {
      getTranscribeWithBookingIdAndPatientId(transcribeId);
    }
  }, [transcribeId]);
  const cleanUp = () => {
    setTranscribeData(null);
    setTranscribeAudioUrl(null);
    setTranscribeOutputUrl(null);
    setTranscribeSummaryUrl(null);
    setFileId(null);
    setTranscribeStatus(null);
    setIsTranscribeConsumed(false);
    setLoading(false);
    setAuthorId(null);
    setAuthorName(null);
    setModalStage(MODAL_STAGES.CONSENT_FORM);
  };

  const getTranscribeWithBookingIdAndPatientId = async id => {
    try {
      setLoading(true);
      const res = await ApiService.getTranscribeById(id);
      if (res.data) {
        setFileId(res.data?.fileUUID);
        setTranscribeStatus(res.data?.status);
        setIsTranscribeConsumed(res.data?.isConsumed);
        if (res.data?.status === "IN_PROGRESS") {
          setModalStage(MODAL_STAGES.RECORD_STAGE);
          setFileId(res.data?.fileUUID);
          setLoading(false);
        }
        if (res.data?.status === "AUDIO_UPLOADED") {
          setModalStage(MODAL_STAGES.RECORD_STAGE);
          setFileId(res.data?.fileUUID);
          getTranscribeAudioUrl(res.data?.fileUUID);
          setLoading(false);
        }
        if (res.data?.status === "AWAITING_TRANSCRIBED_OUTPUT") {
          setModalStage(MODAL_STAGES.RECORD_STAGE);
          setFileId(res.data?.fileUUID);
          getTranscribeAudioUrl(res.data?.fileUUID);
          setLoading(false);
        }
        if (res.data?.status === "COMPLETED") {
          setModalStage(MODAL_STAGES.RECORD_STAGE);
          getTranscribeAudioUrl(res.data?.fileUUID);
          getTranscribeOutput(res.data?.fileUUID);
          setLoading(false);
        }
        if (res.data?.status === "DISCARDED") {
          setModalStage(MODAL_STAGES.RECORD_STAGE);
          setModalStage(MODAL_STAGES.RECORD_STAGE);
          setFileId(res.data?.fileUUID);
          setLoading(false);
        }
      }
    } catch (error) {
      console.log("error in getTrans with booking id and patient id ", error);
    } finally {
    }
  };

  const getTranscribeAudioUrl = async fileId => {
    try {
      const res = await ApiService.getTranscribeUrl(fileId);
      if (res.data) {
        setTranscribeAudioUrl(res.data);
      }
    } catch (error) {
      console.log("error in getTransAudioUrl ", error);
    }
  };

  const getTranscribeOutput = async fileId => {
    try {
      const res = await ApiService.getTranscribeOutput(fileId);
      const res2 = await ApiService.getTranscribeSummary(fileId);
      if (res.data && res2.data) {
        setTranscribeOutputUrl(res.data);
        setTranscribeSummaryUrl(res2.data);
      }
    } catch (error) {
      console.log("error in getTransOutPut with file id ", error);
    }
  };

  const initiateTranscribe = async () => {
    const data = {
      referenceType: referenceType,
      referenceId: referenceId,
      patientId: patientDetails?.userId,
      source: "CLINICIAN_PATIENT_CONVERSATION"
    };
    try {
      const res = await ApiService.startTranscribe(data);
      if (!res.data) alert("Something went wrong");
      setModalStage("record_stage");
      setFileId(res?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const setModalRecordStage = () => {
    initiateTranscribe();
  };

  const saveTranscribeAsChartNote = async (isPublish = false) => {
    const data = {
      personId: patientDetails?.userId,
      note: transcribeData,
      noteType: noteType ? noteType : "CLINICIAN_NOTE",
      referenceId: referenceId,
      referenceType: "BOOKING",
      status: isPublish ? "PUBLISHED" : "DRAFT",
      visibility: "INTERNAL_NOTE",
      authorId: authorId,
      authorName: authorName
    };
    try {
      const res = await ApiService.createChartingNotes(data);
      if (res.data) {
        setSnackOpen(true);
        setSnackText("Transcribe saved as charting notes");
        setSnackSeverity("success");
        await ApiService.consumeTranscribeOutput(fileId);
        setModalStage(MODAL_STAGES.RECORD_STAGE);
        setIsTranscribeConsumed(true);
      }
    } catch (error) {
      console.log("error in create chart note with transcribe ", error);
      setSnackOpen(true);
      setSnackText("Something went wrong");
      setSnackSeverity("error");
    } finally {
      cleanUp();
      onHide();   
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        cleanUp();
        onHide();
      }}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      centered
      style={{}}
    >
      <img src={Beta} alt="logo" style={{ position: "absolute", top: -10, left: -10, width: 120, height: 110 }} />
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{modalStage === MODAL_STAGES.CONSENT_FORM && <h2>Consent Form</h2>}</Modal.Title>
        <AiOutlineClose
          onClick={() => {
            cleanUp();
            onHide();
          }}
          style={{ position: "absolute", top: 20, right: 10, cursor: "pointer" }}
          size={30}
        />
        {modalStage === MODAL_STAGES.SAVE_AS && (
          <AiOutlineArrowLeft
            onClick={() => {
              setModalStage(MODAL_STAGES.RECORD_STAGE);
            }}
            style={{ position: "absolute", top: 20, left: 50, cursor: "pointer" }}
            size={30}
          />
        )}
      </Modal.Header>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div className="loading"></div>
        </div>
      ) : (
        <Modal.Body className="transcribe-modal p-5">
          {modalStage === MODAL_STAGES.CONSENT_FORM && (
            <ConsentForm
              onHide={() => {
                cleanUp();
                onHide();
              }}
              setModalStage={setModalRecordStage}
            />
          )}
          {modalStage === MODAL_STAGES.RECORD_STAGE && (
            <>
              <Form>
                <div className="grid">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Booking ID</Form.Label>
                    <Form.Control type="bookingID" placeholder="" value={referenceDetails?.id} />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" placeholder="" value={referenceDetails?.email} />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Date of Birth</Form.Label>
                    <Form.Control type="dateOfBirth" placeholder="" value={patientDetails?.dob} />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Sex at Birth</Form.Label>
                    <Form.Control type="secAtBirth" placeholder="" value={patientDetails?.genderAtBirth} />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Gender</Form.Label>
                    <Form.Control type="gender" placeholder="" value={patientDetails?.gender} />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Product</Form.Label>
                    <Form.Control type="product" placeholder="" value={getProductNames(referenceDetails?.products)} />
                  </Form.Group>
                </div>
              </Form>

              <RecordSection
                setModalStage={setModalStage}
                clinicianName={referenceDetails?.primaryClinicianName}
                patientName={`${referenceDetails?.firstName} ${referenceDetails?.lastName}`}
                fileId={fileId}
                transcribeAudioUrl={transcribeAudioUrl}
                transcribeOutputUrl={transcribeOutputUrl}
                transcribeSummaryUrl={transcribeSummaryUrl}
                transcribeStatus={transcribeStatus}
                setTranscribeData={setTranscribeData}
                transcribeData={transcribeData}
                errorSuccessHandler={errorSuccessHandler}
                isTranscribeConsumed={isTranscribeConsumed}
              />
            </>
          )}

          {modalStage === MODAL_STAGES.SAVE_AS && (
            <>
              <h3 style={{ textAlign: "center" }}>Save as</h3>

              <div className="mt-4" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", width: "590px", margin: "auto" }}>
                <Form.Check
                  className="my-2 mr-20"
                  type="radio"
                  name="notesOptions"
                  value="CLINICIAN_NOTE"
                  label="Clinical Notes"
                  onChange={e => {
                    setNoteType(e.target.value);
                  }}
                />
                <Form.Check
                  className="my-2 mr-20"
                  type="radio"
                  name="notesOptions"
                  value="APPOINTMENT_NOTE"
                  label="Appointment Notes"
                  onChange={e => {
                    setNoteType(e.target.value);
                  }}
                />
                <Form.Check
                  className="my-2 mr-20"
                  type="radio"
                  name="notesOptions"
                  value="REGISTERED_NURSE_NOTE"
                  label="Registered Nurse Notes"
                  onChange={e => {
                    setNoteType(e.target.value);
                  }}
                />
                <Form.Check
                  className="my-2 mr-20"
                  type="radio"
                  name="notesOptions"
                  value="ANCILLARY_STAFF_NOTE"
                  label="Ancillary Staff Notes"
                  onChange={e => {
                    setNoteType(e.target.value);
                  }}
                />
              </div>

              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Button
                  className="discard-btn mr-2"
                  onClick={() => {
                    saveTranscribeAsChartNote();
                  }}
                >
                  Save as Draft
                </Button>
                <Button
                  onClick={() => {
                    saveTranscribeAsChartNote(true);
                  }}
                  className="record-btn"
                >
                  Save
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      )}
    </Modal>
  );
}
